import { flagBrazil, flagSpain, flagUnitedStates } from '@frontend/assets';
import { InfoLanguage } from '@bandido/shared/types';

export const langConfig = {
  [InfoLanguage.English]: {
    flag: flagUnitedStates,
    text: 'common.language.english',
  },
  [InfoLanguage.Spanish]: {
    flag: flagSpain,
    text: 'common.language.spanish',
  },
  [InfoLanguage.Portuguese]: {
    flag: flagBrazil,
    text: 'common.language.portuguese',
  },
};
